document.addEventListener("DOMContentLoaded", () => {
const wrapper = document.querySelector(".scroll-wrapper");
const slider = document.querySelector(".horizontal-slider");
const indicatorBar = document.querySelector(".indicator-bar");
const slides = Array.from(document.querySelectorAll(".slide"));

/* --------------------------------------------------
   CREATE DOT INDICATORS
-------------------------------------------------- */
slides.forEach((_, i) => {
  const dot = document.createElement("div");
  dot.className = "indicator-dot";
  dot.dataset.index = i;
  indicatorBar.appendChild(dot);

  dot.addEventListener("click", () => {
    goToSlide(i);
  });
});

const dots = Array.from(document.querySelectorAll(".indicator-dot"));

/* --------------------------------------------------
   UPDATE ACTIVE DOT
-------------------------------------------------- */
function updateActiveDot(index) {
  dots.forEach(dot => dot.classList.remove("active"));
  dots[index].classList.add("active");
}

/* --------------------------------------------------
   GO TO SLIDE (scroll smoothly)
-------------------------------------------------- */
function goToSlide(index) {
  isProgrammaticScroll = true;

  const maxScroll = slider.scrollWidth - wrapper.clientWidth;

  const slideCenter = slides[index].offsetLeft + slides[index].offsetWidth / 2;
  const wrapperCenter = wrapper.clientWidth / 2;

  let target = slideCenter - wrapperCenter;
  target = Math.max(0, Math.min(target, maxScroll));

  wrapper.scrollTo({
    left: target,
    behavior: "smooth"
  });

  updateActiveDot(index);
  currentSlide = index;

  // allow observer again AFTER scroll finishes
  setTimeout(() => {
    isProgrammaticScroll = false;
  }, 600); // match scroll duration
}


/* --------------------------------------------------
   SLIDE CLICK → GO TO THAT SLIDE
-------------------------------------------------- */
slides.forEach((slide, i) => {
  slide.addEventListener("click", () => {
    goToSlide(i);
  });
});

/* --------------------------------------------------
   AUTOPLAY
-------------------------------------------------- */

let currentSlide = 0;
const intervalTime = 4000; // autoplay speed (ms)

function autoplay() {
  currentSlide++;

  if (currentSlide >= slides.length) {
    currentSlide = 0; // loop back to start
  }

  goToSlide(currentSlide);
}

let autoTimer = setInterval(autoplay, intervalTime);

/* --------------------------------------------------
   PAUSE AUTOPLAY ON HOVER
-------------------------------------------------- */
wrapper.addEventListener("mouseenter", () => {
  clearInterval(autoTimer);
});

wrapper.addEventListener("mouseleave", () => {
  autoTimer = setInterval(autoplay, intervalTime);
});

/* --------------------------------------------------
   INIT
-------------------------------------------------- */
updateActiveDot(0);

// ---- Auto observe current slide while scrolling ----
const observer = new IntersectionObserver((entries) => {
  if (isProgrammaticScroll) return;  // IGNORE observer during animation

  let best = null;

  entries.forEach(entry => {
    if (entry.intersectionRatio > 0.5) best = entry;
  });

  if (best) {
    const index = slides.indexOf(best.target);
    updateActiveDot(index);
    currentSlide = index;
  }
}, {
  root: wrapper,
  threshold: [0.25, 0.5, 0.75]
});


slides.forEach(slide => observer.observe(slide));
});